import { Inject, Injectable, TransferState, makeStateKey } from '@angular/core';
import { CookieService } from 'ng2-cookies';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { MktEnvironmentService } from './mkt-environment.service';
import * as uuid from 'uuid';
import { Observable } from 'rxjs';
import { BehaviorSubject, ReplaySubject, of, Subscription, Subject } from 'rxjs';
import { catchError, mergeMap, retry } from 'rxjs/operators';
import { AuthorizationService } from '@citi-gcg-173875/citi-security';
import { MktContentStorageService } from './mkt-content-storage.service';
import { DOCUMENT } from '@angular/common';
import { InactivityService } from 'src/app/common/services/inactivity.services';
import { QPStoreService } from 'src/app/common/services/qp-store.service';
import { ACQApplyNowUrlParams } from '../models/acq-apply-now-url-params.model';
import { AdaFriendlyNamePipe } from 'src/app/common/pipes/ada-friendly-name.pipe';
const envs = {
  localhost: 'DEV2',
  dit01: 'DEV1',
  dit02: 'DEV2',
  dit03: 'DEV3',
  test01: 'UAT1',
  test02: 'UAT2',
  test03: 'UAT3',
  test04: 'UAT4',
  loadtest: 'PERF',
  'www.citi.com': 'PROD',
}
const PRICE_DETAILS_KEY = makeStateKey<any>('priceDetails');
const ROCKETFUEL_REGX = /\{.*\}/;
@Injectable({
  providedIn: 'root',
})

export class MktDynamicOfferService {
  public offerDataHash: string;
  public setOfferListObj: any;
  private _cachedDynamicOffer: any;
  private _cachedAllDynamicOffer: any;
  public ipAddress: string;
  private identityLink: any;
  public isSessionActive: boolean = false;
  public ccid: string;
  public ccsid: string;
  private sub: Subscription = new Subscription();

  private bannerContent: Subject<any>;
  public priceDetails: Subject<any>;
  private priceDetailObj: Subject<any>;
  private applyNowURLSubject: BehaviorSubject<any>;

  /** Tagging related variable declaration PE team */

  public datalayerContent = {
    recommendedCards: [],
    travelCards: {},
    crossSellcard: {},
    heroBanner: {}
  };
  public userType: any;
  public objOfferSet = {
    C: 'bank',
    D: 'bank',
    L: 'bank',
    O: 'bank',
    S: 'bank',
    F: 'benefits',
    B: 'branding',
    A: 'content',
    I: 'investment',
    H: 'mortgage',
    M: 'mortgage',
    N: 'mortgage',
    R: 'retirement',
    Q: 'servicing',
    V: 'servicing',
    QLE: 'servicing'
  };
  public objProductLob = {
    'bank': 'b',
    'benefits': 'benefits',
    'branding': 'branding',
    'cards': 'c',
    'content': 'content',
    'investment': 'investment',
    'mortgage': 'm',
    'retirement': 'retirement',
    'servicing': 'servicing'
  }
  public productType;
  public pidptArray;
  public vendorData: any;
  public isTaggingFallback: any = false;
  public rocketFuelDefaultResponse = [{
    "moduletype": "hero-one",
    "pid": "PRQ",
    "contentID": "PRQ_E_B_H1_PQ_0225",
    "templateID": "DPO",
    "positionID": "H1",
    "decisionType": "D",
    "applyNow": "N",
    "titleNode": "ITSS_hd_dynamic",
    "subheadNode": "DYN_OFFER_SUB_HD",
    "clickURL": "https://redirect.api.boomtrain.com/click/citi-sandbox/YrSfm3ek7v79KN+1ecBA5JYnCt7JQI78Lk2NdaCblnQJhkxC4072ySuBBg2TZwkBP5Q7lgqTVoCFU61l/jQNSQ==?rd=https%3A%2F%2Ftest03.creditcards.citi.com%2Fcredit-cards%2Fcompare%2Fview-all-credit-cards&rsid=460e6244-f7a7-496c-a21f-5b2f927199f9&rid=460e6244-f7a7-496c-a21f-5b2f927199f9%3A~MACRO.citi_creative_template.1~%3A0&g=~MACRO.citi_creative_template.1~&n=0&p=False&r=Citicards-91765418&rt=product&x=ZXhwX2J0&rc=Site_Optimizer&t=485360&m=other",
    "sapientURL": "",
    "device": "L",
    "scenarioID": "64062748",
    "creativename": "PRQ_E_B_H1_PQ_0225^^PRQ^X^^D^hero-one",
    "creativeGroupID": "67483655"
  }, {
    "moduletype": "card-banner",
    "pid": "142",
    "contentID": "E_V_S_V5_APP_0125",
    "templateID": "DPO",
    "positionID": "V5",
    "decisionType": "D",
    "applyNow": "N",
    "titleNode": "ITSS_hd_dynamic",
    "subheadNode": "DYN_OFFER_SUB_HD",
    "clickURL": "https://redirect.api.boomtrain.com/click/citi-sandbox/YrSfm3ek7v79KN+1ecBA5JYnCt7JQI78Lk2NdaCblnQJhkxC4072ySuBBg2TZwkBP5Q7lgqTVoCFU61l/jQNSQ==?rd=https%3A%2F%2Ftest03.creditcards.citi.com%2Fcredit-cards%2Fcompare%2Fview-all-credit-cards&rsid=460e6244-f7a7-496c-a21f-5b2f927199f9&rid=460e6244-f7a7-496c-a21f-5b2f927199f9%3A~MACRO.citi_creative_template.2~%3A0&g=~MACRO.citi_creative_template.2~&n=0&p=False&r=Citicards-1027917&rt=product&x=ZXhwX2J0&rc=Site_Optimizer&t=485360&m=other",
    "sapientURL": "",
    "device": "L",
    "scenarioID": "64062748",
    "creativename": "E_V_S_V5_APP_0125^^142^X^^D^card-banner",
    "creativeGroupID": "82927491"
  }
  ]

  DSResponse = {
    // Domain Service Error Code
    DSErrorCode: 'E006',
    // Acxiom DS Failure message
    acxiomDSFailureMessage: '|System error occurred at Citi Acxiom domain service',
    // RF DS Failure message
    rfDSFailureMessage: '|failure',
    // Acxiom DS Success message
    acxiomDSSuccessMessage: '|Success',
    // RF DS Success Message
    RFDSSuccessMessage: '|Success'
  };

  acxiomWSResponse = {
    // acxiom Failure Message
    acxiomWSFailure: 'E003|acxiom error',
    // acxiom Success rCode
    acxiomSuccessRCode: 'I000',
    // acxiom Time Out Code
    acxiomTimeOutCode: 'T000',
    // acxiom Timed Out
    acxiomTimedOut: 'T000|acxiom timed out',
    // attributes not present in response (rCode, rMsg, name)
    Missing_attributes: 'I001|incomplete acxiom response',
    // Https Failure
    httpsFailure: 'E002|acxiom https failure',
    // Experience mismatch from Acxiom response with pageDef(citi.com) value
    Experience_Mismatch: 'E000|experience mismatch',
    // RF Web Service Timed out Status Code
    acxiomTimedOutStatusCode: '408'
  };

  RFWSResponse = {
    // RF Web Service Timed Out
    RFTimedOut: '|RF timed out',
    // RF Error Case Scenario
    RFError: '|RF error',
    // RF Web Service Timed out Status Code
    RFTimedOutStatusCode: '408',
    // RF validation failure
    validation_Failure: '|RF validation failed',
    // Https Failure
    httpsFailure: '|RF https failure',
    // RF parameter (aosResponseCode) to be stored in AOSDMPRF Cookie
    aosResponseCode: 'aos_responseCode'
  };

  blackListKeywords: any;
  whiteListKeywords: any;
  RFMaxLength: any;
  OSResponseStatus: any = '';
  OSResponse = { cmsData: '', cmsMeta: '' };
  offerOrchHttpCode: String = '';

  RFContentData: any = {};
  rfWSStatusCode: String = '';
  RFContentDataBannerService: any = {};
  rfResponse: any;
  responseTextFailedRegEx: any;
  acxiomCookie: any;
  rfDSResponseStatus: any;
  rfWSResponseStatus: any;
  regExOSMeta: any;
  parsedRFDataBannerService: any;
  parsedRFData: any;
  rfResPlKeys: any = [];
  acxiomCitiData = '';
  expAcxiomResponse: any;
  AOSDMPRFCookieCode: any;
  offerPlacements: any;
  offersResCount: any;
  acxiomWSResponseStatus: String = '';
  contentValidationFailure: any;
  placementValidationFailure: any;
  mValidationFailure: any;
  rfHeroModuleCount: any;
  modTwoCount: any;
  rfModuleArr: any = []; // Initialize moduleArr to empty array in order to store module types of each offer from RF response
  rfContentIdArr: any = []; // Initialize contentIdArr to empty array in order to store content Id of each offer from RF response
  rfPlacementsArr: any = [];
  moduleArr = []; // Initialize moduleArr to empty array in order to store module types of each offer from RF response
  contentIdArr = []; // Initialize contentIdArr to empty array in order to store content Id of each offer from RF response
  parsedRFArr: any = [];
  rfTemplateIDFailure: boolean;
  rfWhiteListResult: any = [];
  OSRawResponse: any = {};
  acxiomDSResponseStatus: String = '';
  n: any;
  offerName: string;

  // Custom messages for Orchestration Service Call
  public OSResponseMsg = {
    // Https Failure
    httpsFailure: '|OS https failure',
    // OS response timeout
    timeout: '|OS timed out',
    // OS Error Code
    OSErrorCode: 'E007',
    // OS Error Message
    OSErrorMessage: '|System error occurred at Citi Orchestration service',
    //RF Response Node Failure
    invalidRFResponse: '|Invalid RF response',
    // Offers not present in RF response
    missing_Offers: '|incomplete RF response',
    // Orchestration call success
    OSSuccess: '|OS Success',
    // Invalid OS response
    invalidOSResponse: '|Invalid OS response'
  };

  public offerListTagging = [];
  public pricingDetails = {};

  public taggingDlArr = {
    action_type: 'page view',
    pid: '',
    bullseye_success: '',
    banner_array: [],
    serverSideBullseye: true,
    BannerOSSuccess: '',
    BannerOSFailure: '',
    AcxiomDSSuccess: '',
    AcxiomDSFailure: '',
    acxiomFailure: '',
    acxiomResponse: '',
    RocketFuelDSSuccess: '',
    RocketFuelDSFailure: '',
    rfFailure: '',
    rfResponse: '',
    cmsFailureMessage: '',
    cmsSuccessResponse: '',
    acxiomToZeta: '',
    app_hierarchy: '',
    prospect_id: '',
    offerListJson: '',
    liveRampResponse: '',
    liveRampIndicator: {
      callStatus: '-', // callStatus - check whether LiveRamp call success or error.  [1->(lr call success),0->(lr timedout/failed),- ->(no call)]
      idlResponse: '-', // idlResponse - set indicator depends upon response from LiveRamp call . 1->XY, 0->empty, 2->Xc, 3->Xi, - -> (no call)
      idlLinkInOS: '0', // idlLinkInOS - indicates if os request had idl value. 1->(idl in os), 0->(idl not in os)
      responseTime: 0 // responseTime  - response time in ms for the LiveRamp call
    }

  };
  bannerResponse: any;

  /** End variable declaration for Tagging */

  constructor(private http: HttpClient,
    private ada: AdaFriendlyNamePipe,
    private _cookieService: CookieService,
    private mktEnvironmentService: MktEnvironmentService,
    private authService: AuthorizationService,
    private _contentStorageService: MktContentStorageService,
    private _inactivityService: InactivityService,
    private _transferState: TransferState,
    private qpStoreService: QPStoreService,
    @Inject(DOCUMENT) private document: Document) {
    this._cachedDynamicOffer = {};
    this._cachedAllDynamicOffer = {};
    this.bannerContent = new Subject<any>();
    this.priceDetails = new Subject<any>();
    this.priceDetailObj = new Subject<any>();
    this.applyNowURLSubject = new BehaviorSubject<any>(this.mktEnvironmentService.getEnvironmentVar('PRE_QUAL_URL'));
  }

  getProductType() {
    const bannerConfigContent = this._contentStorageService.get('Branding', 'copy', 'BannerConfig', undefined);
    this.productType = JSON.parse(bannerConfigContent.productType || '{}');
  }

  setBannerContent(bannerContent): void {
    this.bannerContent.next(bannerContent);
  }

  getBannerContent(): Observable<any> {
    return this.bannerContent.asObservable();
  }

  setApplyNowContent(applyNowContnet): void {
    this.applyNowURLSubject.next(applyNowContnet);
  }

  setPriceDetails(priceList): void {
    this.priceDetails.next(priceList);
  }

  getPriceDetails(): Observable<any> {
    return this.priceDetails.asObservable();
  }

  // Only For PDP pages
  setPriceDetailObj(priceObj): void {
    this.priceDetailObj.next(priceObj);
  }

  // Only for PDP pages
  getPriceDetailObj(): Observable<any> {
    return this.priceDetailObj.asObservable();
  }

  getApplyNowContent(): Observable<any> {
    return this.applyNowURLSubject.asObservable();
  }

  public getDynamicOffer(pageId, pid, affinityId, hashCode, productType = null): Observable<any> {
    let storageId = [pageId, pid, affinityId, hashCode, (productType || 'NA')].join('|');
    if (!this._cachedDynamicOffer[storageId]) {
      this._cachedDynamicOffer[storageId] = new ReplaySubject<Response>(1);
      this._getDynamicOffer(pageId, pid, affinityId, hashCode, productType).toPromise().then(resp => this._cachedDynamicOffer[storageId].next(resp));
    }
    return this._cachedDynamicOffer[storageId].asObservable();
  }

  private _getDynamicOffer(pageId, pid, affinityId, hashCode, productType = null) {
    const APP_VERSION = this.mktEnvironmentService.getEnvironmentVar('APP_VERSION');
    const CBOL_CLIENT_ID = this.mktEnvironmentService.getEnvironmentVar('CBOL_CLIENT_ID');
    const ENDPOINT2_URL = this.mktEnvironmentService.getEnvironmentVar('DYNAMIC_PRICING_ENDPOINT1_URL');
    const AOSDMPRF = this._cookieService.get('AOSDMPRF');

    let dynamicPricingHeaders = new HttpHeaders().set('client_id', CBOL_CLIENT_ID).set('appversion', APP_VERSION);//.set('X-Migration-Target', 'PAS2');
    let endpoint2Payload = {};
    let offerList = { 'cardOffers': [] };
    if (AOSDMPRF) {
      offerList = this.convertAosdmprfCookieToOfferList(AOSDMPRF, pid);
    }
    // uncomment below line if need to use hashcode from Cookie
   //   hashCode = !hashCode && this.qpStoreService.getHashCode(pid);
    if (!!hashCode) offerList.cardOffers.push({ type: '', 'hashCode': hashCode, 'pid': pid, 'offerDisplayType': '', }); // DYNAMICE OFFER SUPPORT ADDED
    endpoint2Payload = this.getEndpointPayloadFromBannerResponse(affinityId, offerList, pid, productType);
    if (pageId == 'CitiRAFNGA') {
      endpoint2Payload["rewardProgramType"] = "RAF";
    }
    return this.http.post(ENDPOINT2_URL, endpoint2Payload, { headers: dynamicPricingHeaders, withCredentials: true })
      .pipe(
        catchError(async error => {
          await this._inactivityService.deleteToken().toPromise();
          throw ('##RETRY');
        }),
        retry(1),
      );
  }

  getOfferList() {
    return this.setOfferListObj;
  }

  setOffers(offerList) {
    this.setOfferListObj = offerList;
  }

  public getAllDynamicOffer(pageId, pid, affinityId, category, isBannerCallRequired = false, rewardProgramType = ""): Observable<any> {
    let storageId = [pageId, pid, affinityId, category].join('|');
    if (!this._cachedAllDynamicOffer[storageId]) {
      this._cachedAllDynamicOffer[storageId] = new ReplaySubject<Response>(1);
      this.sub.add(this._getAllDynamicOffer(pageId, pid, affinityId, category, isBannerCallRequired, rewardProgramType).subscribe({ next: resp => this._cachedAllDynamicOffer[storageId].next(resp), error: _ => this._cachedAllDynamicOffer[storageId].next(null) }));
    }
    return this._cachedAllDynamicOffer[storageId].asObservable();
  }

  private _getAllDynamicOffer(pageId, pid, affinityId, category, isBannerCallRequired = false, rewardProgramType) {
    const BANNER_URL = this.mktEnvironmentService.getEnvironmentVar('BANNER_CLIENT_URL');
    const ENDPOINT3_URL = this.mktEnvironmentService.getEnvironmentVar('DYNAMIC_PRICING_ENDPOINT2_URL');
    const BANNER_CLIENT_ID = this.mktEnvironmentService.getEnvironmentVar('BANNER_CLIENT_ID');
    const APP_VERSION = this.mktEnvironmentService.getEnvironmentVar('APP_VERSION');
    const bannerHeaders = new HttpHeaders().set('client_id', BANNER_CLIENT_ID);

    const CBOL_CLIENT_ID = this.mktEnvironmentService.getEnvironmentVar('CBOL_CLIENT_ID');
    let dynamicPricingHeaders = new HttpHeaders().set('client_id', CBOL_CLIENT_ID).set('appversion', APP_VERSION);

    const bannerPayload = this.getBannerPayload(pageId, pid, category);
    const AOSDMPRF = this._cookieService.get('AOSDMPRF');

    let endpoint3Payload = {};
    let bannerReq: Observable<any>;
    if (isBannerCallRequired) {
      bannerReq = this.http.post(BANNER_URL, bannerPayload, { headers: bannerHeaders, withCredentials: true });
    } else {
      bannerReq = of(null);
    }
    return bannerReq
      .pipe(
        catchError(error => {
          this.taggingDlArr.BannerOSFailure = this.OSResponseMsg.OSErrorCode + this.OSResponseMsg.OSErrorMessage;
          let httpError = (error['error'] && error['error']['httpCode']) ? error['error']['httpCode'] : error.status;
          window['citiData']['errorCode'] = `${pid} error page:${this.OSResponseMsg.OSErrorCode}:${this.OSResponseMsg.OSErrorMessage}`;
          this.setAosdmprfFailCookie(httpError);
          return of(false);
        }),
        mergeMap(bannerResponse => {
          let offerList = (AOSDMPRF) ? this.convertAosdmprfCookieToOfferList(AOSDMPRF) : { 'cardOffers': [] };
          if(isBannerCallRequired){
            if (!bannerResponse) this.setBannerContent({ ContentData: this.rocketFuelDefaultResponse });
            else {
              this.offerOrchHttpCode = '200';
              this.taggingDlArr.BannerOSSuccess = (this.taggingDlArr.BannerOSFailure == '') ? this.OSResponseMsg.OSSuccess : '';
              this.bannerResponse = bannerResponse;
              this.processRocketFuelResponse(bannerResponse);
              if (!!bannerResponse['acxiomCookie']) {
                // Set the AOSDMPRF cookie
                const acxiomCookie = bannerResponse['acxiomCookie'];
                this._cookieService.set('AOSDMPRF', acxiomCookie, undefined, '/credit-cards');
                offerList = this.convertAosdmprfCookieToOfferList(acxiomCookie);
              }
            }
          }
          const priceDetails = this._transferState.get(PRICE_DETAILS_KEY, []);
          if (priceDetails.length > 0 && pageId !== 'CITICRSNGA') {
            return of({ pricingDetails: priceDetails });
          }
          else {
            // get offerList values from cookie if hashcode from Cookie
            offerList = this.qpStoreService.getOfferListFromCookie(offerList);
            endpoint3Payload = this.getEndpointPayloadFromBannerResponse(affinityId, offerList);
            endpoint3Payload["rewardProgramType"] = rewardProgramType;
            endpoint3Payload["offerDataHash"] = this.offerDataHash || '';
            if (pageId == 'CitiPQPS') {
              delete endpoint3Payload['affinityID'];
              delete endpoint3Payload['cardOffers'];
            }
            return this.http.post(ENDPOINT3_URL, endpoint3Payload, { headers: dynamicPricingHeaders, withCredentials: true })
              .pipe(
                catchError(async error => {
                  await this._inactivityService.deleteToken().toPromise();
                  throw ('##RETRY');
                }),
                retry(1),
              );
          }
        })
      );
  }

  private processRocketFuelResponse(bannerResponse) {
    bannerResponse = (typeof (bannerResponse) !== 'object') ? JSON.parse(bannerResponse) : bannerResponse;
    if (!!bannerResponse['rocketFuelResponse'] && !!bannerResponse['rocketFuelResponse']['rocketFuelResponse'] && !!bannerResponse['rocketFuelResponse']['rocketFuelResponse']['ContentData'] && !!bannerResponse['rocketFuelResponse']['rocketFuelResponse']['ContentData']['rf_placement1']) {
      this.populateSCInfo(bannerResponse);
      const updatedBannerResponse = this._getRFPlcementsBannerResponse(bannerResponse);
      this.setBannerContent(updatedBannerResponse['rocketFuelResponse']['rocketFuelResponse'] || {});
    }else{
      this.setBannerContent({ ContentData: this.rocketFuelDefaultResponse });
    }
  }

  private _getRFPlcementsBannerResponse(bannerResponse) {
    let data = []
    const contentData = bannerResponse?.rocketFuelResponse?.rocketFuelResponse?.ContentData || {};
    Object.values(contentData).forEach((value) => {
      data.push(value);
    });
    bannerResponse['rocketFuelResponse']['rocketFuelResponse']['ContentData'] = data;
    return bannerResponse;
  }

  setLiveRampPixel() {
    return new Promise(e => {
      let t = document.createElement("IMG"),
        cuuid = this.getCuuid(),
        n = "https://id.rlcdn.com/501099.gif?partner_uid=" + cuuid;
      t.setAttribute("src", n),
        t.addEventListener("load", function () {
          e(t);
        }),
        t.addEventListener("error", function () {
          e(null);
        }),
        t.addEventListener("abort", function () {
          e(null);
        }),
        setTimeout(function () {
          e(null);
        }, 700);
    }
    ).then(e => {
      e || console.log("Pixel load timed out. Triggering the idl api call"),
        this.getIDLParam()
    }
    ).catch(e => {
      console.log("Pixel failed. Triggering the idl api call ", e),
        this.getIDLParam()
    }
    )
  }

  getIDLParam() {
    let startTime = new Date().getTime();
    return new Promise<any>((resolve, error) => {
      this.http.get(`https://api.rlcdn.com/api/identity?pid=1&rt=idl`, {
        withCredentials: true,
        headers: {
          'Accept': 'application/json, text/javascript, */*; q=0.01',
          'Content-Type': 'text/plain;charset=UTF-8'
        }
      })
        .toPromise()
        .then((response: HttpResponse<any>) => {
          let respTime = new Date().getTime() - startTime;
          this.taggingDlArr.liveRampIndicator.responseTime = respTime;
          if (response) {
            this.taggingDlArr.liveRampIndicator.callStatus = '1';
            let lrResponse = (response['idl'] && response['idl'] != 'undefined') ? response['idl'].substring(0, 2) : '';
            this.taggingDlArr.liveRampIndicator.idlResponse = (lrResponse != '') ? ((lrResponse == 'XY') ? '1' : ((lrResponse == 'Xc') ? '2' : ((lrResponse == 'Xi') ? '3' : '-'))) : '0';
            resolve(response);
          } else {
            this.taggingDlArr.liveRampIndicator.callStatus = '0';
            throw new Error(`Status: ${response.status} ${response.statusText}`);
          }
        })
        .catch(err => error(err));
    });
  }

  convertAosdmprfCookieToOfferList(AOSDMPRF, productIdentifier=null) {
    AOSDMPRF = AOSDMPRF.replace('aos_offers=', '');

    const offerListString = AOSDMPRF.split('&')[0];

    const offerListStringArray = offerListString.split('|');

    let offerList = [];
    for (let i = 0; i < offerListStringArray.length; i++) {
      let offer = {};
      const splitOfferArray = offerListStringArray[i].split('-');
      offer['type'] = splitOfferArray[0];
      offer['hashCode'] = splitOfferArray[1];
      offer['pid'] = splitOfferArray[2];
      offer['offerDisplayType'] = splitOfferArray[5];
      this.offerListTagging.push(offer);
      if (!!offer['hashCode'] && (offer['offerDisplayType'] === 't' || offer['offerDisplayType'] === 'c')) {
        offerList.push(offer);
      }
    }
    if(!!productIdentifier) offerList = offerList.filter(({pid}) => productIdentifier === pid)[0] || [];
    return { 'cardOffers': offerList };
  }

  getEndpointPayloadFromBannerResponse(affinityID, offerList = { 'cardOffers': [] }, pid = null, productType = null) {
    let afc= affinityID; // Explore/VAC/MPP Page
    if(pid){ // PDP Page - override afc only if HKOP present in cookie
      afc = this.qpStoreService.isExistingProduct(pid) && !!this.qpStoreService.getHashcodeFromCookie(pid) ? '' : affinityID;
      }
    let endpoint2Payload = {
      'affinityID': afc,
      'cardOffers': offerList['cardOffers']
    };
    pid && (endpoint2Payload['pid'] = pid);
    productType && (endpoint2Payload['productType'] = productType);
    return endpoint2Payload;
  }

  buildApplyNowUrl(screenId, intc, cardName, pid, hashCode, isDefaultOffer) {
    // https://www.citicards.com/cards/credit/application/flow.action?app=UNSOL&HKOP=69ece8e6f8e0a8e0d49373e659065751f264c7e4ba0d779721a2e198eb7231d1&ID=3000&ProspectID=P2x1JFCnGklherpENYKZYUb0QjFG9stF&intc=7~7~66~1~PDP~1~CMSDefaultOffer&cmv=490&pid=142&walletSegment=C181_01&rCode=I000
    const { APPLY_NOW_BASE_URL } = this.getMigrationUrls(pid);

    let cmv = '';
    let walletSegment = '';
    let rCode = '';

    let adobe_mc = this.getAdobeMcCookie();
    let AOSDMPRF = this._cookieService.get('AOSDMPRF');
    if (AOSDMPRF) {
      AOSDMPRF = AOSDMPRF.replace('aos_offers=', '');

      const aosdmprfAndSplit = AOSDMPRF.split('&');
      const offerListString = aosdmprfAndSplit[0];

      walletSegment = this.searchAosdmprfCookie('aos_cat=', AOSDMPRF);
      rCode = this.searchAosdmprfCookie('aos_responseCode=', AOSDMPRF);

      const offerListStringArray = offerListString.split('|');

      let offerList = [];
      for (let i = 0; i < offerListStringArray.length; i++) {
        let offer = {};
        const splitOfferArray = offerListStringArray[i].split('-');
        if (splitOfferArray[2] === pid) {
          cmv = splitOfferArray[6];
        }
      }
    }

    // Generate random var in this service
    const PROSPECT_ID = this.generateProspectId();
    const appendLoginString = `${this.isUserLoggedIn() ? 'Y' : ''}`;
    let formatedURL = '';
    if (cardName == "CitiRAFNGA")
      formatedURL = `HKOP=${hashCode}&ID=${screenId}&ProspectID=${PROSPECT_ID}${cmv !== '' ? '&cmv=' + cmv : ''}&pid=${pid}${walletSegment !== '' ? '&walletSegment=' + walletSegment : ''}${rCode !== '' ? '&rCode=' + rCode : ''}${appendLoginString !== '' ? '&login=' + appendLoginString : ''}${adobe_mc !== '' ? '&adobe_mc=' + adobe_mc : ''}`;
    else
      formatedURL = `HKOP=${hashCode}&ID=${screenId}&ProspectID=${PROSPECT_ID}&intc=${intc}~${isDefaultOffer ? 'CMSDefaultOffer' : cardName}${cmv !== '' ? '&cmv=' + cmv : ''}&pid=${pid}${walletSegment !== '' ? '&walletSegment=' + walletSegment : ''}${rCode !== '' ? '&rCode=' + rCode : ''}${appendLoginString !== '' ? '&login=' + appendLoginString : ''}${adobe_mc !== '' ? '&adobe_mc=' + adobe_mc : ''}`;

    return this.qpStoreService.buildQPString(APPLY_NOW_BASE_URL, formatedURL);
  }

  getMbolApplyNowUrl(pid, hashCode, app = 'UNSOL') {
    let adobe_mc = this.getAdobeMcCookie();
    // https://www.citi.com/cards/flow.action?HKOP=69ece8e6f8e0a8e0d49373e659065751f264c7e4ba0d779721a2e198eb7231d1&status=Redirect2Mbol
    const { APPLY_NOW_MBOL_BASE_URL } = this.getMigrationUrls(pid, app);
    let status = "Redirect2Mbol";
    return `${APPLY_NOW_MBOL_BASE_URL}&HKOP=${hashCode}&pid=${pid}&status=${status}${adobe_mc !== '' ? '&adobe_mc=' + adobe_mc : ''}`;
  }

  getACQApplyNowUrl(params: ACQApplyNowUrlParams): string {
    const {
      screenId,
      intc,
      cardName,
      pid,
      hashCode,
      isDefaultOffer,
      afc,
      soc,
      rafid,
      rafcategory,
      app = 'UNSOL',
    } = params;

    const { APPLY_NOW_BASE_URL } = this.getMigrationUrls(pid, app);
    const adobe_mc = this.getAdobeMcCookie();
    const AOSDMPRF = this._cookieService.get('AOSDMPRF');
    const { cmv, walletSegment, rCode } = this.extractAosdmprfData(AOSDMPRF, pid);

    const PROSPECT_ID = this.generateProspectId();
    this.offerName = rafcategory === "raf-aadvantage-credit-card-page" ? "raf_landing_page" : "CMSDefaultOffer";
    const appendLoginString = this.isUserLoggedIn() ? 'Y' : '';

    const formattedQS = this.buildQueryString({
      HKOP: hashCode,
      ID: screenId,
      ProspectID: PROSPECT_ID,
      intc,
      offerName: isDefaultOffer ? this.offerName : cardName,
      cmv,
      pid,
      walletSegment,
      rCode,
      afc,
      login: appendLoginString,
      soc,
      rafid,
      adobe_mc,
    });

    return this.qpStoreService.buildQPString(APPLY_NOW_BASE_URL, formattedQS);
  }

  private extractAosdmprfData(AOSDMPRF: string, pid: string) {
    if (!AOSDMPRF) return { cmv: '', walletSegment: '', rCode: '' };

    const cleanedAOSDMPRF = AOSDMPRF.replace('aos_offers=', '');
    const aosdmprfAndSplit = cleanedAOSDMPRF.split('&');
    const offerListString = aosdmprfAndSplit[0];

    const walletSegment = this.searchAosdmprfCookie('aos_cat=', cleanedAOSDMPRF);
    const rCode = this.searchAosdmprfCookie('aos_responseCode=', cleanedAOSDMPRF);

    const cmv = offerListString
      .split('|')
      .map(offer => offer.split('-'))
      .find(splitOfferArray => splitOfferArray[2] === pid)?.[6] || '';

    return { cmv, walletSegment, rCode };
  }

  private buildQueryString(params: Record<string, string | undefined>) {
    return Object.entries(params)
      .filter(([_, value]) => value !== undefined && value !== '')
      .map(([key, value]) => `${key}=${value}`)
      .join('&');
  }

  getPricingInfoUrl(pid, hashCode, app = 'UNSOL') {
    const { DISPLAY_TERMS_BASE_URL } = this.getMigrationUrls(pid, app);
    return `${DISPLAY_TERMS_BASE_URL}&HKOP=${hashCode}`;
  }

  getAdobeMcCookie(): string {
    let adobe_mc = '';
    let AMCV = this._cookieService.get(decodeURIComponent('AMCV_61834D9B5228A7430A490D45%40AdobeOrg'));
    if (AMCV) {
      let AMCV_VALUES = decodeURIComponent(AMCV).split('|');

      AMCV_VALUES.forEach((key, index) => {
        if (key == 'MCMID') {
          adobe_mc += 'MCMID=' + AMCV_VALUES[index + 1];
        } else if (key == 'MCAID') {
          if (adobe_mc != '' && adobe_mc.length) { adobe_mc += ',' }
          adobe_mc += 'MCAID=' + AMCV_VALUES[index + 1];
        }
      });
      adobe_mc = encodeURIComponent(adobe_mc);
    }
    return adobe_mc;
  }

  getMigrationUrls(pid, app = 'UNSOL') {
    const key = Object.keys(envs).filter(env => this.document.location.href.includes(env))[0];
    const ENV = !!key ? envs[key] : 'PROD';
    const environmentContent = this._contentStorageService.get('Branding', 'copy', 'BannerConfig', undefined);
    const prodTypeData = JSON.parse(environmentContent['prodType'] || `{}`);
    let pricingInfoUrl = this.mktEnvironmentService.getEnvironmentVar('ACQ_BASE_URL');
    let applyNowUrl = this.preQualUrl();
    let applyNowUrlMBOL = this.preQualUrl();
    if (app) {
      applyNowUrl = applyNowUrl.replace('=UNSOL', '=' + app);
      applyNowUrlMBOL = applyNowUrlMBOL.replace('=UNSOL', '=' + app);
      pricingInfoUrl = pricingInfoUrl.replace('=UNSOL', '=' + app);
    }
    const dynamicURLs = {
      DISPLAY_TERMS_BASE_URL: pricingInfoUrl,
      APPLY_NOW_BASE_URL: this.appendParamToApplyNowFlow(applyNowUrl, prodTypeData[pid]),
      APPLY_NOW_MBOL_BASE_URL: applyNowUrlMBOL
    }
    return dynamicURLs;
  }

  // NCDDM-7499: Add Parameter for ACQ Apply Now from Citicards.com driven through ICMS
  appendParamToApplyNowFlow(url, prodTypeValue) {
    return (prodTypeValue) ? `${url}&prodType=${prodTypeValue}` : url;
  }

  acqBaseUrl(pid) {
    const { DISPLAY_TERMS_BASE_URL } = this.getMigrationUrls(pid)
    return DISPLAY_TERMS_BASE_URL;
  }

  preQualUrl() {
    const PRE_QUAL_URL = this.mktEnvironmentService.getEnvironmentVar('PRE_QUAL_URL');
    return PRE_QUAL_URL;
  }

  cbolUrl() {
    const CBOL_URL = this.mktEnvironmentService.getEnvironmentVar('CBOL_URL');
    return CBOL_URL;
  }

  cbolNGAUrl() {
    const CBOL_URL = this.mktEnvironmentService.getEnvironmentVar('CBOL_NGA_URL');
    return CBOL_URL;
  }

  cbolSSRUrl() {
    const CBOL_URL = this.mktEnvironmentService.getEnvironmentVar('CBOL_SSR_URL');
    return CBOL_URL;
  }

  appStatusUrl() {
    const APP_STATUS_BASE_URL = this.mktEnvironmentService.getEnvironmentVar('APP_STATUS_BASE_URL');
    return APP_STATUS_BASE_URL;
  }

  isUserLoggedIn(): boolean {
    this.sub.add(this.authService.getSessionObservable().subscribe(bool => this.isSessionActive = !!bool));
    return this.isSessionActive;
  }

  searchAosdmprfCookie(searchFragment, aosdmprfCookie) {
    if (aosdmprfCookie.indexOf(searchFragment) !== -1) {
      let rCodeSubString = aosdmprfCookie.substring(aosdmprfCookie.indexOf(searchFragment), aosdmprfCookie.length);
      let rCodeIndex = rCodeSubString.split('&')[0];
      return rCodeIndex.substring(searchFragment.length, rCodeIndex.length);
    } else {
      return '';
    }
  }

  generateProspectId() {
    let result = 'P';
    const CHARACTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const CHARACTERS_LENGTH = CHARACTERS.length;
    const crypto = window.crypto;
    const rnArr = new Uint32Array(32);
    crypto.getRandomValues(rnArr);
    for (let i = 0; i < 31; i++) {
      result += CHARACTERS.charAt(rnArr[i] % CHARACTERS_LENGTH);
    }
    return result;
  }

  getBannerPayload(pageId, pid, category) {

    this.identityLink = this._cookieService.get('liveRamp');
    this.getCcid();
    let mockBannerPayload = {
      'rocketFuel': {
        'xpUserId': this._cookieService.get('RFXPUID')
      },
      'acxiom': {
        'acxiomCookie': this._cookieService.get('AOSDMPRF'),
        'subChannelId': 'DIRECT',
        'axdpCookie': this._cookieService.get('axDP'),
        'axdsCookie': this._cookieService.get('axDS')
      },
      'customerIdDetails': [{
        'customerIdentifier': this.ccsid,
        'customerIdType': 'CCSID'
      },
      {
        'customerIdentifier': this.ccid,
        'customerIdType': 'CCID'
      }],
      'metaData': {
        'browserWidth': window.innerWidth,
        'browserHeight': window.innerHeight,
        'deviceSize': this.getDeviceSize(),
        'ipAddress': this.mktEnvironmentService.getEnvironmentVar('IP_ADDRESS'),
        'popDigit': this.getPopDigit(),
        'returningUserFlag': this.getVnValue(),
        'userId': this.getCuuid(),
        'entryPointFlag': 'Y',
        'recentlyComparedCard': this._cookieService.get('compareCards'),
        'recentlyViewedCard': this.getRecentlyViewedCookie(pageId, pid, category),
        'source': 'cc',
        'dmpPresentFlag': this._cookieService.get('BKDMP') ? 'Y' : 'N',
        'visiterNumber': this.n,
        'acxiomRequiredFlag': 'false',
        'ecmCookie': this._cookieService.get('CBOLECM'),
        'rocketFuelRequiredFlag': 'true',
        'sourceUrl': this.getSourceUrl(),
        'javaEnabledFlag': this.isJavaEnabled(),
        'screenResolution': `${window.screen.availWidth}x${window.screen.availHeight}`,
        'pageId': pageId,
        'identityLink': this.identityLink
      }
    };

    if (window['global_liveRampResponse']) {
      window['global_liveRampResponse'].idlLinkInOS = (mockBannerPayload.metaData.identityLink) ? '1' : '0'; //modifying liveramp indicator value for os
    }

    return mockBannerPayload;
  }

  getDeviceSize() {
    const width = window.innerWidth;
    if (width > 983) {
      return 'L';
    } else if (width > 599) {
      return 'M';
    } else {
      return 'S';
    }
  }

  getPopDigit() {
    const popsplit = this._cookieService.get('popsplit');
    if (!popsplit || parseInt(popsplit, 10) > 99) {
      const DATE = new Date();
      const crypto = window.crypto;
      const rnArr = new Uint32Array(1);
      crypto.getRandomValues(rnArr);
      DATE.setTime(DATE.getTime() + (3600 * 1000 * 24 * 365));
      const newPopsplit = Math.floor((rnArr[0] % 100));
      this._cookieService.set('popsplit', newPopsplit.toString(), DATE, '/');
      return newPopsplit;
    } else {
      let temp_pd = (this._cookieService.get('popsplit') == null ? '0' : this._cookieService.get('popsplit'));
      if (temp_pd.indexOf(':') !== -1) {
        temp_pd = temp_pd.substring(0, temp_pd.indexOf(':'));
      }
      return temp_pd;
    }
  }

  getVnValue() {
    let e = (new Date).getTime() - 18e5
    let t = this._cookieService.get("s_pers") ? decodeURIComponent(this._cookieService.get("s_pers")) : ""
      , i = "NEW"
      , n = 1;
    if (t = t ? decodeURIComponent(t) : t) {
      let o = t ? t.split("&vn=") : []
        , a = o.length > 0 ? o[1].split("|") : []
        , s = t.split("s_nr=")
        , r = s.length > 0 ? s[1].split("-") : [];
      if (a.length > 0) {
        let c = parseInt(r[0]) - e;
        i = parseInt(a[0]) > 1 || 1 == parseInt(a[0]) && c < 0 ? "REPEAT" : i,
          this.n = parseInt(a[0]) > 1 ? a[0] : 1 == parseInt(a[0]) && c < 0 ? parseInt(a[0]) + 1 : n
        return i;
      }
    }
  }

  getCcid() {
    var ccsidCcid = this._cookieService.get("ccid_ccsid");
    if (ccsidCcid) {
      var splitCookie = (ccsidCcid = decodeURI(ccsidCcid)).split("|");
      splitCookie && splitCookie.length > 0 ? (this.ccsid = splitCookie[1] ? splitCookie[1] : this.ccsid,
        this.ccid = splitCookie[0] ? splitCookie[0] : this.ccid) : (this.ccsid = this.ccsid,
          this.ccid = this.ccid)
    }
  }

  getCuuid() {
    let cuuid = this._cookieService.get('CUUID');
    if (!cuuid) {
      const DATE = new Date();
      DATE.setTime(DATE.getTime() + (3600 * 1000 * 24 * 365));
      const newCuuid = uuid.v4();
      this._cookieService.set('CUUID', newCuuid, DATE, '/');
      return newCuuid;
    } else {
      return cuuid;
    }
  }

  getSourceUrl() {
    try {
      const referrer = document.referrer;
      return (referrer.indexOf('?') !== -1 ? referrer.substring(0, referrer.indexOf('?')) : referrer);
    } catch (err) {
      return '';
    }
  }

  isJavaEnabled() {
    let isJavaEnabled = (typeof navigator.javaEnabled() != 'undefined' && typeof navigator.javaEnabled() != null) ? navigator.javaEnabled() : false;
    return isJavaEnabled;
  }

  getRecentlyViewedCookie(pageId, pid, category) {
    if (pageId && pid && category) {
      const DATE = new Date();
      DATE.setTime(DATE.getTime() + (3600 * 1000 * 24 * 365));
      let cookieString = `${pageId}:${pid}:${category}`;
      this._cookieService.set('recentlyViewed', cookieString, DATE);
      return cookieString;
    } else {
      return this._cookieService.get('recentlyViewed');
    }
  }

  setAosdmprfFailCookie(httpStatus) {
    let aosdmprfFailCookie = '';
    this.offerOrchHttpCode = httpStatus;
    if (httpStatus >= 400) {
      aosdmprfFailCookie = `aos_responseCode=E002&aos_httpStatus=${httpStatus}`;
      this._cookieService.set('AOSDMPRF', aosdmprfFailCookie, undefined, '/credit-cards');
    }
  }
  populateSCInfo(bannerResponse) {
    let rfResponseData = bannerResponse.rocketFuelResponse.rocketFuelResponse.ContentData;
    let acxiomResponse = bannerResponse.acxiomResponse;
    if (acxiomResponse != null) {
      acxiomResponse = (this.taggingDlArr.acxiomResponse) ? this.taggingDlArr.acxiomResponse : JSON.stringify(bannerResponse.acxiomResponse);
    }
    let SuccessResponseData = rfResponseData.rf_placement1;
    let cmsSuccessResponse = SuccessResponseData.contentID + '|' + '1' + '|' + SuccessResponseData.templateID;
    window['citiData']['rfFailure'] = '';
    window['citiData']['acxiomFailure'] = '';
    window['citiData']['cmsFailureMessage'] = '';
    window['citiData']['rfResponse'] = rfResponseData ? rfResponseData : '';
    window['citiData']['acxiomResponse'] = acxiomResponse ? acxiomResponse : '';
    window['citiData']['cmsSuccessResponse'] = cmsSuccessResponse ? cmsSuccessResponse : '';
    window['citiData']['RocketFuelDSSucess'] = 'Success';
    window['citiData']['serverSideBullseye'] = true;
    window['citiData']['eventList'] = 'banImp';
    this.populateTaggingInfo();
  }
  callRfxpuidurl(rfxpuidurl) {
    const RFXPUID = this._cookieService.get('RFXPUID');
    if (!RFXPUID) {
      document.getElementById('rfxpuidurlDiv').innerHTML = '<img role="presentaion" aria-hidden="true" style="display:none" src="' + rfxpuidurl + '"/>';
    }
  }

  /** Tagging Modification PE team related all codes*/

  /** set icms content into specific variables like vendorData, regExOSMeta, offerPlacements , isTaggingFallback
   * vendorData => all whitelist, blacklist parameter,regex patterns
   * offerPlacements => [1,2,3,4]
   * isTaggingFallback default value "false"
   */

  setTaggingStaticIcms(icmscontent) {
    if (icmscontent) {
      this.vendorData = JSON.parse(icmscontent.TEXT);
      this.regExOSMeta = new RegExp(this.vendorData.OS.OSMetaData);
      this.offerPlacements = JSON.parse(icmscontent.offerPlacement);
      this.isTaggingFallback = icmscontent.isTaggingFallback;
    }
  }

  /*** Method to set the offertype like hero recommended travel cross-sell and there respective values */
  setStaticContentDataLayer(offerType, offer) {
    this.datalayerContent[offerType] = offer;
  }

  populateDynamicOfferListValuesTagging(pidArr) {
    let product_dtls = [];
    for (let i = 0; i < pidArr.length; i++) {
      let pid = pidArr[i];
      product_dtls.push(this.productType[pid]);
    };
    let offJsonArr = {
      "card1": product_dtls[0],
      "card2": product_dtls[1],
      "card3": product_dtls[2]
    }
    return JSON.stringify(offJsonArr);
  }

  /** Method to implement BRD logic for dynamic and static offers */
  populateTaggingInfo() {
    const bannerResponse = this.bannerResponse;
    this.getProductType();
    // Setting acxiom_resp_to_zeta code to taggingDlArr
    try {
      const AOSDMPRF = this._cookieService.get('AOSDMPRF');
      if (bannerResponse) {

        try {
          let rocketFuelRequestString = (bannerResponse.rocketFuelResponse.rocketFuelRequest.match(ROCKETFUEL_REGX) != null) ? bannerResponse.rocketFuelResponse.rocketFuelRequest.match(ROCKETFUEL_REGX)[0] : '';
          let parsedData = JSON.parse(rocketFuelRequestString);
          this.taggingDlArr.acxiomToZeta = (parsedData.Data && parsedData.Data.ssv_resp) ?
            'acxiom_resp_to_zeta=' + parsedData.Data.ssv_resp : '';
        } catch (e) {
          this.taggingDlArr.acxiomToZeta = '';
        }
        this.validateOSRes(bannerResponse);
      }

      let obj;
      let category;
      let product;
      let pid;
      let title;
      let banner_title;
      let product_details;
      let bannerDescription = '';
      let description;
      let bannerArray = [];
      let rfResponseData = (bannerResponse && bannerResponse.rocketFuelResponse) ? bannerResponse.rocketFuelResponse.rocketFuelResponse.ContentData : '';
      this.taggingDlArr.rfResponse = (typeof rfResponseData != 'undefined' && rfResponseData) ? rfResponseData : '';
      let pidArray = [];
      let pidObjOfferlistSession = {};
      let offerList = { 'cardOffers': [] };
      let acxiomCookie = (bannerResponse && bannerResponse.rocketFuelResponse && bannerResponse['acxiomCookie']) ? bannerResponse['acxiomCookie'] : AOSDMPRF;
      offerList = (bannerResponse && bannerResponse.rocketFuelResponse && acxiomCookie) ? this.convertAosdmprfCookieToOfferList(acxiomCookie) : offerList;
      let positionID = 0;
      let cms_contentID = '';
      // Hero banner array creation for dynamic and default
      if (this.datalayerContent.recommendedCards && typeof this.datalayerContent.heroBanner['bannerContent'] != 'undefined') {
        this.datalayerContent.recommendedCards.unshift(this.datalayerContent.heroBanner);
      }
      if (this.datalayerContent.recommendedCards.length > 0) {
        let recommendedArray = this.datalayerContent.recommendedCards;
        if (this.offerListTagging.length > 0) {
          this.offerListTagging.filter(function (x) {
            recommendedArray.forEach(function (item) {
              if (item.bannerContent.pid === x.pid) {
                pidObjOfferlistSession[x.pid] = {
                  'pid': x.pid,
                  'schsh': x.schsh,
                  'type': x.type
                }
              }
            })
          })
        }
        for (let i = 0; i < this.datalayerContent.recommendedCards.length; i++) {
          positionID = i + 1;
          let allDynamicOffers = this.datalayerContent.recommendedCards[i];

          title = (typeof allDynamicOffers.selectedBanner.cardName != 'undefined' && allDynamicOffers.selectedBanner.cardName) ?
            this.ada.sanitizePlainText(allDynamicOffers.selectedBanner.cardName) : ''; // removing tags like <sup></sup>
          banner_title = (title) ? title.replace(/&(?:[a-z]+|#x?\d+);/gi, '') : ''; // removing &reg; like <sup></sup>

          description = (typeof allDynamicOffers.selectedBanner.defaultOffer != 'undefined' && allDynamicOffers.selectedBanner.defaultOffer.description) ?
            allDynamicOffers.selectedBanner.defaultOffer.description
            : ((typeof allDynamicOffers.selectedBanner.cardDescription != 'undefined') ? allDynamicOffers.selectedBanner.cardDescription : '');


          pid = (typeof allDynamicOffers.bannerContent.pid != 'undefined') ? allDynamicOffers.bannerContent.pid : '';
          pidArray.push(pid);

          if (this.pricingDetails && typeof this.pricingDetails[pid] != 'undefined') {
            let tempElement = document.createElement('tr');
            tempElement.innerHTML = description; // Parse the string as HTML into the row
            let spans = tempElement.querySelectorAll('span'); // Gather up the spans
            if (spans && spans.length > 0) {
              for (let i = 0; i < spans.length; i++) {
                this.pricingDetails[pid].filter(function (x) {
                  if (x.keytomatch == spans[i].dataset.id) {

                    let value = x.value;
                    switch (x.key) {
                      case 'balconMinimumFee':
                      case 'accountLevelBalconMinimumFee':
                        value = value * 10;
                        break;
                      case 'balconFeeRate':
                        value = value / 10;
                        break;
                      case 'accountLevelBalconFeeRate':
                        value = value / 10;
                        break;
                      case 'bonusAmount':
                      case 'hurdleAmount':
                        value = value !== undefined ? value.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : '';
                        break;
                      default:
                        value = value ?? '';
                    }
                    description = description.replace(spans[i].outerHTML, value);
                  }
                })
              }
            }
          }
          let removeTag = (description) ? this.ada.sanitizePlainText(description).toString() : '';
          bannerDescription = (removeTag) ? removeTag.replace(/&(?:[a-z]+|#x?\d+);/gi, '') : ''; // removing &reg; like <sup></sup>


          cms_contentID = (typeof allDynamicOffers.bannerContent.contentID != 'undefined') ? ((!cms_contentID) ? allDynamicOffers.bannerContent.contentID : cms_contentID + '|' + allDynamicOffers.bannerContent.contentID) : cms_contentID;
          this.taggingDlArr.cmsSuccessResponse = cms_contentID;
          if (bannerResponse && bannerResponse.rocketFuelResponse) {
            product_details = this.productType[pid];
            // Dynamic hero offer
            category = this.setCategory(pid);
            product = (category && this.objProductLob && this.objProductLob[category]) ? this.objProductLob[category] + ':' + pid : '';
            category = category + ':offers';
          } else {
            //default hero offer
            let cms_contentID_default = (typeof allDynamicOffers.bannerContent.contentID != 'undefined') ? allDynamicOffers.bannerContent.contentID : '';
            category = (pid && pid.length == 3 && pid.match(/\D/) == null) ? 'cards default:offers' : 'unspecified default:offers';
            product = (pid && pid.length == 3 && pid.match(/\D/) == null) ? 'c:' + pid : 'contentID:' + cms_contentID_default;
            product_details = this.productType[pid];
          }
          obj = {
            category: category,
            product_name: product,
            acquisition_source_code: (bannerResponse && pidObjOfferlistSession[pid] && typeof pidObjOfferlistSession[pid].schsh != 'undefined' && pidObjOfferlistSession[pid].schsh) ? pidObjOfferlistSession[pid].schsh : '',
            product_details: 'type=' + product_details,
            cms_contentID: (typeof allDynamicOffers.bannerContent.contentID != 'undefined') ? allDynamicOffers.bannerContent.contentID : '',
            scenarioID: (bannerResponse && typeof allDynamicOffers.bannerContent.scenarioID != 'undefined') ? allDynamicOffers.bannerContent.scenarioID : '',
            contentID: (typeof allDynamicOffers.bannerContent.contentID != 'undefined') ? allDynamicOffers.bannerContent.contentID : '',
            banner_creative: (bannerResponse && typeof allDynamicOffers.bannerContent.creativename != 'undefined') ? allDynamicOffers.bannerContent.creativename : '',
            positionID: positionID,
            banner_layout: (typeof allDynamicOffers.bannerContent.moduletype != 'undefined') ? allDynamicOffers.bannerContent.moduletype : '',
            banner_title: banner_title,
            banner_description: bannerDescription
          }
          bannerArray.push(obj);
        }
      }

      // travel offers array creation
      if (Object.keys(this.datalayerContent['travelCards']).length > 0 && this.datalayerContent['travelCards']) {
        let cardDetails = this.datalayerContent.travelCards['cardOptions'][0];
        pid = (cardDetails['productIdentifier'] != 'undefined') ? (cardDetails['productIdentifier'].toString()) : '';
        pidArray.push(pid);
        // set category for static offer
        category = this.setCategory(pid);
        product = (category && this.objProductLob && this.objProductLob[category]) ? this.objProductLob[category] + ':' + pid : '';
        category = category + ' static:offers';
        product_details = this.productType[pid];
        title = (typeof cardDetails['displayName'] != 'undefined' && cardDetails['displayName']) ?
          this.ada.sanitizePlainText(cardDetails['displayName']) : ''; // removing tags like <sup></sup>
        banner_title = (title) ? title.replace(/&(?:[a-z]+|#x?\d+);/gi, '') : ''; // removing &reg; like <sup></sup>
        description = (typeof cardDetails['defaultOffer'].description != 'undefined' && cardDetails['defaultOffer'].description) ?
          this.ada.sanitizePlainText(cardDetails['defaultOffer'].description) : ''; // removing tags like <sup></sup>
        bannerDescription = (description) ? description.replace(/&(?:[a-z]+|#x?\d+);/gi, '') : ''; // removing &reg; like <sup></sup>
        positionID = positionID + 1;
        let contentID = (typeof this.datalayerContent.travelCards['staticContent']['contentId'] != 'undefined') ? this.datalayerContent.travelCards['staticContent']['contentId'] : '';
        let moduletype = (typeof this.datalayerContent.travelCards['staticContent']['moduletype'] != 'undefined') ? this.datalayerContent.travelCards['staticContent']['moduletype'] : '';
        this.taggingDlArr.cmsSuccessResponse = (contentID) ? ((this.taggingDlArr.cmsSuccessResponse) ? this.taggingDlArr.cmsSuccessResponse + '|' + contentID : contentID) : this.taggingDlArr.cmsSuccessResponse;
        obj = {
          category: category,
          product_name: product,
          acquisition_source_code: '',
          product_details: 'type=' + product_details,
          cms_contentID: contentID,
          scenarioID: '',
          contentID: contentID,
          banner_creative: '',
          positionID: positionID,
          banner_layout: moduletype,
          banner_title: banner_title,
          banner_description: bannerDescription
        }
        bannerArray.push(obj);
      }

      // cross sell card  offers array creation
      if (Object.keys(this.datalayerContent['crossSellcard']).length > 0 && this.datalayerContent['crossSellcard']) {
        title = (typeof this.datalayerContent['crossSellcard']['title'] != 'undefined' && this.datalayerContent['crossSellcard']['title']) ?
          this.ada.sanitizePlainText(this.datalayerContent['crossSellcard']['title']) : ''; // removing tags like <sup></sup>
        banner_title = (title) ? title.replace(/&(?:[a-z]+|#x?\d+);/gi, '') : ''; // removing &reg; like <sup></sup>
        description = (typeof this.datalayerContent['crossSellcard']['desc'] != 'undefined' && this.datalayerContent['crossSellcard']['desc']) ?
          this.ada.sanitizePlainText(this.datalayerContent['crossSellcard']['desc']) : ''; // removing tags like <sup></sup>
        bannerDescription = (description) ? description.replace(/&(?:[a-z]+|#x?\d+);/gi, '') : ''; // removing &reg; like <sup></sup>
        positionID = positionID + 1;
        let contentID = (typeof this.datalayerContent['crossSellcard']['contentId'] != 'undefined') ? this.datalayerContent['crossSellcard']['contentId'] : '';
        let moduletype = (typeof this.datalayerContent['crossSellcard']['moduletype'] != 'undefined') ? this.datalayerContent['crossSellcard']['moduletype'] : '';
        this.taggingDlArr.cmsSuccessResponse = (contentID) ? ((this.taggingDlArr.cmsSuccessResponse) ? this.taggingDlArr.cmsSuccessResponse + '|' + contentID : contentID) : this.taggingDlArr.cmsSuccessResponse;
        pid = 'B000';
        pidArray.push(pid);
        obj = {
          category: 'bank static:offers',
          product_name: 'b:B000',
          acquisition_source_code: '',
          product_details: 'type=banking unknown',
          cms_contentID: contentID,
          scenarioID: '',
          contentID: contentID,
          banner_creative: '',
          positionID: positionID,
          banner_layout: moduletype,
          banner_title: banner_title,
          banner_description: bannerDescription
        }
        bannerArray.push(obj);
      }
      this.taggingDlArr.pid = (pidArray.length > 0) ? pidArray.toString() : '';
      let idlValue = (window['global_liveRampResponse'].idlRespons && window['global_liveRampResponse'].idlRespons == '-') ? window['global_liveRampResponse'].idlRespons : ((window['global_liveRampResponse'].idlRespons) ? window['global_liveRampResponse'].idlRespons.substring(0, 2) : '');
      let lrResponse = (idlValue != '') ? ((idlValue == 'XY') ? '1' : ((idlValue == 'Xc') ? '2' : ((idlValue == 'Xi') ? '3' : '-'))) : '0';
      let liveRampResponse = 'lr:' + window['global_liveRampResponse'].callStatus + '|idl:' + lrResponse +
        '|os:' + window['global_liveRampResponse'].idlLinkInOS + '|t:' + window['global_liveRampResponse'].liveRamp_time;

      /** bulls eye success creation  */
      let dataToAppend: any;
      let appendPipne = '|';
      dataToAppend = (this.taggingDlArr.serverSideBullseye) ? 'sv' : 'cs';
      let bullseye_success = dataToAppend + appendPipne;
      dataToAppend = (this.taggingDlArr.BannerOSSuccess == '|OS Success') ? 1 : ((this.taggingDlArr.BannerOSSuccess == '|OS Failure' || this.taggingDlArr.BannerOSFailure) ? 0 : '-');
      bullseye_success = bullseye_success + 'bos:' + dataToAppend + appendPipne;
      dataToAppend = (this.taggingDlArr.AcxiomDSSuccess == '|Success') ? 1 : ((this.taggingDlArr.AcxiomDSSuccess == '|Failure' || this.taggingDlArr.AcxiomDSFailure) ? 0 : '-');
      bullseye_success = bullseye_success + 'dsa:' + dataToAppend + appendPipne;
      dataToAppend = (this.taggingDlArr.acxiomFailure) ? 0 : ((this.taggingDlArr.acxiomResponse === null || this.taggingDlArr.acxiomResponse) ? 1 : '-');
      bullseye_success = bullseye_success + 'ax:' + dataToAppend + appendPipne;
      dataToAppend = (this.taggingDlArr.RocketFuelDSSuccess == '|Success' || this.taggingDlArr.RocketFuelDSSuccess) ? 1 : ((this.taggingDlArr.RocketFuelDSFailure) ? 0 : '-');
      bullseye_success = bullseye_success + 'dsr:' + dataToAppend + appendPipne;
      dataToAppend = (this.taggingDlArr.rfFailure != '' && this.taggingDlArr.rfFailure) ? 0 : ((this.taggingDlArr.rfResponse != '' && this.taggingDlArr.rfResponse) ? 1 : '-');
      bullseye_success = bullseye_success + 'rf:' + dataToAppend + appendPipne;
      bullseye_success = bullseye_success + 'cms:' + 1;

      this.taggingDlArr.bullseye_success = bullseye_success;
      this.taggingDlArr.banner_array = bannerArray;
      let offerListJson = this.populateDynamicOfferListValuesTagging(pidArray);
      this.taggingDlArr.liveRampResponse = liveRampResponse;
      this.taggingDlArr.offerListJson = offerListJson;
      const prospect_id = this.generateProspectId();
      this.taggingDlArr.prospect_id = prospect_id;
      /** call tagging method to insert data into _dl */
    } catch (e) {
      console.log('tagging errorOccurs here: ', e.message);
    }
  }

  validateOSRes(response: any) {

    // Get acxiom cookie if it exists
    const AOSDMPRF = this._cookieService.get('AOSDMPRF');
    this.acxiomCookie = (AOSDMPRF != null && response.acxiomResponse == null) ? AOSDMPRF : '';

    this.blackListKeywords = this.vendorData?.OS?.blackListKeywords;
    this.whiteListKeywords = this.vendorData?.OS?.whiteListVariables;
    this.RFMaxLength = this.vendorData?.OS?.payloadSize;

    let acxiomDSStatus;
    let rfDSStatus;

    const httpStatusOS = parseInt(this.offerOrchHttpCode + '');
    if (httpStatusOS == undefined || !(httpStatusOS <= 200 && httpStatusOS < 300)) {
      this.OSResponseStatus = this.OSResponseMsg.invalidOSResponse;
      this.updateOSResponse([], this.OSResponseMsg.httpsFailure);
    }

    // Checking for Acxiom Domain Service Status
    try {
      acxiomDSStatus = response.acxiomDomainResponseStatus;
      rfDSStatus = response.rocketFuelDomainResponseStatus;

      // Checking for Acxiom Domain Service Status
      if (acxiomDSStatus != null) {
        if (this.acxiomCookie === '') {
          if (acxiomDSStatus === 'Success') {
            this.taggingDlArr.AcxiomDSSuccess = this.DSResponse.acxiomDSSuccessMessage;
          } else {
            this.taggingDlArr.AcxiomDSFailure = this.DSResponse.DSErrorCode + this.DSResponse.acxiomDSFailureMessage;
          }
        }
      }

      // Checking for RF Domain Service Status
      if (rfDSStatus != null && rfDSStatus) {
        if (rfDSStatus === 'Success') {
          this.taggingDlArr.RocketFuelDSSuccess = this.DSResponse.RFDSSuccessMessage;
        } else {
          this.taggingDlArr.RocketFuelDSFailure = this.DSResponse.rfDSFailureMessage;
        }
      } else {
        this.rfDSResponseStatus = this.DSResponse.rfDSFailureMessage;
      }

      const acxiomValidated = this.validatingAcxiomResponse(response, acxiomDSStatus);
      if (!acxiomValidated) {
        return;
      }

      // Processing on RF Web service Response
      try {
        if (rfDSStatus === 'Success') {
          // Fetching RF ContentData from OS Response
          this.RFContentData = response.rocketFuelResponse.rocketFuelResponse.ContentData;
          this.RFContentData = (this.RFContentData != null) ? JSON.stringify(this.RFContentData) : '';
          this.rfWSStatusCode = response.rocketFuelResponse.statusCode;

          /*
            Fetching whole RF ContentData along with Banner Service CMS from OS Response
            containing Banner Service throttle decision for CMS Call
          */
          this.RFContentDataBannerService = response.rocketFuelResponse.rocketFuelResponse.ContentData;
          this.RFContentDataBannerService = (this.RFContentDataBannerService != null) ?
            JSON.stringify(this.RFContentDataBannerService) : '';
          if (this.RFContentDataBannerService != '') {
            this.rfResponse = this.RFContentDataBannerService;
          }
        } else {
          this.RFContentDataBannerService = '';
          return;
        }
      } catch (e) {
        this.rfWSResponseStatus = this.RFWSResponse.RFError;
        return;
      }

    } catch (e) {
      this.OSResponseStatus = this.OSResponseMsg.invalidOSResponse; // Storing invalid OSResponse Status for updating in tagging object
      this.updateOSResponse([], this.OSResponseStatus);
      return;
    }

    try {
      if (this.OSResponseStatus == '') {
        this.taggingDlArr.BannerOSSuccess = this.OSResponseMsg.OSSuccess;
      }
      const rf_bannerService = (typeof response.rocketFuelResponse.rocketFuelResponse.ContentData.rf_bannerService !== 'undefined' &&
        response.rocketFuelResponse.rocketFuelResponse.ContentData.rf_bannerService !== '')
        ? response.rocketFuelResponse.rocketFuelResponse.ContentData.rf_bannerService : 'N';
      // Setting callCMSServiceRFDecision to true if rf_bannerService is found in RFResponse. Require offer.jws call.
      // Otherwise set to false if rf_bannerService is not found in RFResponse. Require NGABannerService call.
    } catch (e) {
      console.log('tagging errorOccurs', e.message);
    }

    // Test ResponseText against Regular expression
    this.responseTextFailedRegEx = this.regExOSMeta?.test(this.RFContentDataBannerService);

    // Parsed RF Response data with Banner Service throttle decision for CMS Call
    this.parsedRFDataBannerService = JSON.parse(this.RFContentDataBannerService);

    this.parsedRFData = JSON.parse(this.RFContentData);
    this.rfResPlKeys = Object.keys(this.parsedRFData);

    this.parseRFPlacementObjects();

    // Offers in RF Response
    this.offersResCount = (typeof this.parsedRFData !== 'undefined') ? this.rfResPlKeys.length : 0;

    this.contentValidationFailure = false;
    this.placementValidationFailure = false;
    this.mValidationFailure = false;
    this.rfHeroModuleCount = 0;
    this.modTwoCount = 0;
    const offerPl = (typeof this.offerPlacements !== 'undefined') ? this.offerPlacements.length : 0; // Default Offers

    // Push each RF placement object into an array, and place the module type of each object into another array


    // RF Content Validation
    this.rfContentValidation();

    // Checking recommended-cards module on 2,3,4 consecutive places in RF response.
    if (this.modTwoCount === 3 && !(this.rfModuleArr[1] === 'recommended-cards' && this.rfModuleArr[2] === 'recommended-cards' && this.rfModuleArr[3] === 'recommended-cards')) {
      this.updateOSResponse([], this.RFWSResponse.validation_Failure);
      return;
    }

    // Blacklist validation
    const foundBlacklistMatch = this.rfBlacklistValidation();

    // Max length, Regular expression, hero module duplication and presence,
    // offers presence, total number of offers, invalid module,duplicate consecutive modules validation
    if ((this.RFContentDataBannerService.length > this.RFMaxLength) || this.responseTextFailedRegEx || this.contentValidationFailure
      || this.rfHeroModuleCount !== 1 || this.mValidationFailure || this.offersResCount === 0 || (offerPl !== this.offersResCount)
      || this.placementValidationFailure || this.rfTemplateIDFailure || (this.modTwoCount !== 0 && this.modTwoCount !== 3)
      || foundBlacklistMatch) {
      this.updateOSResponse([], this.RFWSResponse.validation_Failure);
      return;
    }

    // Whitelist validation
    const whitelistValidationFailed = this.rfWhitelistValidation(this.parsedRFDataBannerService);

    if ((this.OSRawResponse != null) && (this.parsedRFDataBannerService != null)) {
      // Store the RF Raw response in the global variable OSRawResponse for BDD - Automation testing
      this.OSRawResponse.rfResponse = this.parsedRFDataBannerService;
    }

    // Call parseRFRes if no validation has failed
    if (!whitelistValidationFailed) {
      this.parseRFRes(this.parsedRFData);
    }

    // Updating Acxiom domain Service failure code and message in taggingDlArr object and create AOSDMPRF Cookie with Acxiom DS Error code
    if (this.acxiomCookie == '' && this.acxiomDSResponseStatus == this.DSResponse.acxiomDSFailureMessage) {
      this.taggingDlArr.AcxiomDSFailure = this.DSResponse.DSErrorCode + this.DSResponse.acxiomDSFailureMessage;
    }

    // Updating RF domain Service failure code and message in taggingDlArr object
    if (this.rfDSResponseStatus == this.DSResponse.rfDSFailureMessage) {
      this.DSResponse.rfDSFailureMessage = this.DSResponse.rfDSFailureMessage;
    }

    // Updating acxiom WS failure message in taggingDlArr object
    // When rCode is empty and acxiomResponse object is null and create AOSDMPRF cookie with Acxiom Error code
    if (this.acxiomCookie == '' && acxiomDSStatus == 'Success' && this.acxiomWSResponseStatus == this.acxiomWSResponse.acxiomWSFailure) {
      this.taggingDlArr.acxiomFailure = this.acxiomWSResponse.acxiomWSFailure;
    }

    // Updating RF WS failure message in tagging object  - When RocketFuelResponseObject is null
    if (rfDSStatus == 'Success' && this.rfWSResponseStatus == this.RFWSResponse.RFError) {
      this.taggingDlArr.rfFailure = this.RFWSResponse.RFError;
    }

    // Happy flow - OS,DS,WS
    const OSResponse = this.OSResponse;
    if (this.OSResponseStatus == '') {
      // Updating OS Success Message in tagging object
      this.taggingDlArr.BannerOSSuccess = this.OSResponseMsg.OSSuccess;
      if (this.rfDSResponseStatus == '' && this.rfWSResponseStatus == '' && rfDSStatus == 'Success') {
        if (OSResponse.cmsData != '') {
          // Updating RFResponse in tagging object with raw RF Response
          this.taggingDlArr.rfResponse = this.RFContentDataBannerService;
        }
        if (OSResponse.cmsMeta != '') {
          // Updating RF Response validation Failure Message to tagging object elements
          this.taggingDlArr.rfFailure = OSResponse.cmsMeta;
        }
        if (this.rfWSStatusCode == this.RFWSResponse.RFTimedOutStatusCode) {
          // Updating RFFailure in tagging object  with RF timed out message when RF web service timed out
          this.taggingDlArr.rfFailure = this.RFWSResponse.RFTimedOut;

        }
        else {
          const rfWSStatusCodeNumber = Number(this.rfWSStatusCode);
          if (!(rfWSStatusCodeNumber >= 200 && rfWSStatusCodeNumber < 300)) {
            // Updating RFFailure in tagging object with raw RF Response
            this.taggingDlArr.rfFailure = this.RFWSResponse.httpsFailure;

          }
        }
      }
    }
  }

  validatingAcxiomResponse(response, acxiomDSStatus) {
    let acxiomValidationSuccess = true;
    try {

      // Process the Acxiom Response if the acxiom cookie is not null or undefined.
      if (this.acxiomCookie === '') {

        if (acxiomDSStatus === 'Success') {
          const acxiomHttpsCode = response.acxiomResponse.statusCode;

          if (acxiomHttpsCode >= 200 && acxiomHttpsCode < 300) {

            // Fetch Acxiom rCode from Acxiom response
            const acxiomRCode = response.acxiomResponse.AcxiomDetail.rCode;

            // Fetch acxiom Cookie from OS Response
            const acxiomCookieResponse = response.acxiomCookie;

            if (acxiomRCode === this.acxiomWSResponse.acxiomSuccessRCode) { // Only if Acxiom rCode = I000

              // Attributes of Acxiom response from OS response and processing them
              const axAttrArray = response.acxiomResponse.AcxiomDetail.attributes;
              this.processAxciomDetailAttributes(axAttrArray, acxiomRCode);

              // Get offer list and process the list and to store them into session storage
              const axOfferListArr = response.acxiomResponse.AcxiomDetail.ofrlst;

              if (this.acxiomCitiData !== '' && this.AOSDMPRFCookieCode == null) {
                this.taggingDlArr.acxiomResponse = this.acxiomCitiData;
              }

              if (this.OSRawResponse != null && response.acxiomResponse.AcxiomDetail != null) {
                this.OSRawResponse.acxiomResponse = response.acxiomResponse.AcxiomDetail;
              }

            } else { // Do the following if the acxiomRCode is not I000

              if (acxiomRCode !== this.acxiomWSResponse.acxiomTimeOutCode) {

                // Update acxiomFailure in tagging object with acxiom error message
                // Update this.AOSDMPRFCookieCode with acxiom error code
                this.AOSDMPRFCookieCode = this.RFWSResponse.aosResponseCode + '=' + (this.acxiomWSResponse.acxiomWSFailure).split('|')[0];

              }

              if (acxiomRCode === '' && acxiomHttpsCode !== '') {

                if (acxiomHttpsCode === this.acxiomWSResponse.acxiomTimedOutStatusCode) {

                  // Assign this.AOSDMPRFCookieCode with time out Error Code
                  this.AOSDMPRFCookieCode = this.RFWSResponse.aosResponseCode +
                    '=' + (this.acxiomWSResponse.acxiomTimedOut).split('|')[0];
                  // Update in tagging object with https status code
                  this.taggingDlArr.acxiomFailure = this.acxiomWSResponse.acxiomTimedOut;

                } else {

                  // Assign this.AOSDMPRFCookieCode with https failure Error Code
                  this.AOSDMPRFCookieCode = this.RFWSResponse.aosResponseCode +
                    '=' + (this.acxiomWSResponse.httpsFailure).split('|')[0];
                  // Update in tagging object with https status code
                  this.taggingDlArr.acxiomFailure = this.acxiomWSResponse.httpsFailure;

                }

              }
            }

          } else { // Do the following if the HTTP code is not in the 200 range
            if (acxiomHttpsCode === this.acxiomWSResponse.acxiomTimedOutStatusCode) {
              this.taggingDlArr.acxiomFailure = this.acxiomWSResponse.acxiomTimedOut;
            } else {
              this.taggingDlArr.acxiomFailure = this.acxiomWSResponse.httpsFailure;
            }
          }

        }

      }
    } catch (e) {
      this.acxiomWSResponseStatus = this.acxiomWSResponse.acxiomWSFailure;
      acxiomValidationSuccess = false;
    }
    return acxiomValidationSuccess;
  }

  processAxciomDetailAttributes(acxiomAttributes: any, acxiomRCode: any): void {
    this.checkUserType();

    //swapping array elements position
    let index1, index2, temp;
    acxiomAttributes.some(function (item, i) {
      if (item.name === 'cat') {
        index1 = i;
      } else if (item.name == 'ep') { index2 = i; }
    });
    temp = acxiomAttributes[index1];
    acxiomAttributes[index1] = acxiomAttributes[index2];
    acxiomAttributes[index2] = temp;
    if (acxiomAttributes != null) {
      acxiomAttributes.forEach((axciomAttribute) => {
        const attrValue = axciomAttribute.value; // Fetching attribute value of params in Axciom response attributes
        if (attrValue !== '') {
          switch (axciomAttribute.name) {
            case 'tx':
              this.acxiomCitiData += attrValue + '|';
              break;
            case 'ep':
              this.acxiomCitiData += attrValue + '|';
              break;
            case 'cat':
              this.acxiomCitiData += attrValue + '|';
              break;
            case 'ex':
              this.expAcxiomResponse = attrValue;

              // Check if the user type is a mismatch with the experience attribute.
              if (this.userType !== ''
                && this.expAcxiomResponse.toLowerCase() !== this.userType.toLowerCase()) {
                this.taggingDlArr.acxiomFailure = this.acxiomWSResponse.Experience_Mismatch;
                this.AOSDMPRFCookieCode = this.RFWSResponse.aosResponseCode + '=' + this.acxiomWSResponse.Experience_Mismatch.split('|')[0];
              }
              break;
            default: break;
          }
        }
      });
    }
    if (acxiomAttributes == null || acxiomAttributes.length === 0) {
      this.taggingDlArr.acxiomFailure = this.acxiomWSResponse.Missing_attributes;
      this.AOSDMPRFCookieCode = this.RFWSResponse.aosResponseCode + '=' + (this.acxiomWSResponse.Missing_attributes).split('|')[0];
    } else {
      this.acxiomCitiData += acxiomRCode;
    }
  }

  parseRFPlacementObjects() {
    // Push RF Response into parsedRFArr Array
    this.rfResPlKeys.forEach((key) => {
      this.parsedRFArr.push(this.parsedRFData[key]);
      if (this.parsedRFData[key].moduletype != null) {
        // Push module type of each element of response into this.rfModuleArr as elements
        this.rfModuleArr.push(this.parsedRFData[key].moduletype);
      }
      if (this.parsedRFData[key].contentID != null) {
        this.rfContentIdArr.push(this.parsedRFData[key].contentID);
      }
      if (this.parsedRFData[key] != null) {
        this.rfPlacementsArr.push(this.parsedRFData[key]);
      }
    });
  }

  rfContentValidation() {
    const regExContent: any = /^[a-zA-Z0-9_]+$/; // regular expression for content ID (alpha-numeric and _ only)
    const regExModule: any = /^[a-z-]+$/; // regular expression for module (alphabets and - only)
    const contentDuplicationCheck: any = {}, rfResPlKeysDuplicationValidation: any = {};

    for (let i = 0; i < this.parsedRFArr.length; i++) {

      // Check if content ID is a valid one
      const cIDLength = (typeof this.parsedRFArr[i].contentID !== 'undefined') ? (this.parsedRFArr[i].contentID).length : 0;
      if (this.parsedRFArr[i].contentID == null || !regExContent.test(this.parsedRFArr[i].contentID) || cIDLength > 32) {
        this.contentValidationFailure = true;
      }

      // Check for duplication of content IDs and rf_placement key duplication
      if (!this.contentValidationFailure) {
        if (this.parsedRFArr[i].contentID != null && contentDuplicationCheck[this.parsedRFArr[i].contentID] != null) {
          this.contentValidationFailure = true;
        } else {
          if (this.parsedRFArr[i].contentID != null) {
            contentDuplicationCheck[this.parsedRFArr[i].contentID] = true;
          }
        }
        if (rfResPlKeysDuplicationValidation[this.rfResPlKeys[i]] != null) {
          this.placementValidationFailure = true;
        } else {
          rfResPlKeysDuplicationValidation[this.rfResPlKeys[i]] = true;
        }
      }

      // Increment Hero module count when hero modules are found
      if (typeof this.parsedRFArr[i].moduletype !== 'undefined' && ((this.parsedRFArr[i].moduletype).indexOf('hero') !== -1)) {
        this.rfHeroModuleCount++;
      }

      // Invalid module name in RF Response
      if (typeof this.parsedRFArr[i].moduletype !== 'undefined' && !regExModule.test(this.parsedRFArr[i].moduletype)) {
        this.mValidationFailure = true;
      }

      // Increment recommended-cards module count when recommended-cards module is found
      if (typeof this.rfModuleArr[i] !== 'undefined' && this.rfModuleArr[i] === 'recommended-cards') {
        this.modTwoCount++;
      }

      // update RF WS Validation Failure message when RF doesn't send template/template is null or empty for any of the offer
      if (this.parsedRFArr[i].templateID == null || this.parsedRFArr[i].templateID === '') {
        this.updateOSResponse([], this.RFWSResponse.validation_Failure)
        this.rfTemplateIDFailure = true;
        return;
      }

      // Checking for consecutive duplicate offers if no modTwo module is present
      if (!(this.rfModuleArr[i] === 'recommended-cards' && (i === 1 || i === 2 || i === 3))) {
        // Checking if consecutive offers in RF Response has same module types
        if (this.mValidationFailure !== true && (i < (this.offersResCount - 1)) && this.rfModuleArr[i] === this.rfModuleArr[i + 1]) {
          this.mValidationFailure = true;
        }
      }

    }
  }

  // Parse RF Response to store it in Var to use for CMS Call
  // cmsData format : cid|placement|module|clickUrl
  parseRFRes(RFRes: any) {
    try {
      if (RFRes) {
        const offerList = [], // Temp array for storing offers during parse
          clickUrlArray = []; // Temp array for storing click URL
        Object.keys(RFRes).forEach((key) => {
          const cID = (RFRes[key].contentID != null) ? RFRes[key].contentID.trim() : '', // Fetch ContentId from RF Response
            module = (RFRes[key].moduletype != null) ? RFRes[key].moduletype.trim() : '', // Fetch module from RF Response
            clickUrl = (RFRes[key].clickURL != null) ? RFRes[key].clickURL : '', // Fetch clickURL from RF Response
            placement = (key !== null && key !== '') ? key.match(/\d+/g) : ''; // Fetch Placement # from RF response
          offerList.push(cID + '|' + placement + '|' + module); // Push contentID, placement, module into temp array for CMSData

        });
        this.updateOSResponse(offerList.toString(), ''); // Store parsed offers in var for CMS Call
      }
      else {
        this.updateOSResponse([], this.OSResponseMsg.missing_Offers); // No offers in RF Response
      }
    }
    catch (e) {
      this.updateOSResponse([], e.message);
    }
  }

  updateOSResponse(responseDataOS: any, responseStatus: any) {
    this.OSResponse.cmsData = responseDataOS;
    this.OSResponse.cmsMeta = responseStatus;
  }

  rfBlacklistValidation(): boolean {
    for (let i = 0; i < this.blackListKeywords.length; i++) {
      if (this.RFContentDataBannerService.indexOf(this.blackListKeywords[i]) !== -1) {
        this.updateOSResponse([], this.RFWSResponse.validation_Failure);
        return true;
      }
    }
    return false;
  }

  rfWhitelistValidation(parsedRFDataBannerService: any): boolean {
    if (parsedRFDataBannerService != null && parsedRFDataBannerService.length !== 0) {
      Object.keys(parsedRFDataBannerService).forEach((key) => {
        if ((!this.rfWhiteListResult.includes(key)) && (!Array.isArray(parsedRFDataBannerService))) {
          if (!this.whiteListKeywords.includes(key)) {
            this.updateOSResponse([], this.RFWSResponse.validation_Failure);
            return true;
          }
          this.rfWhiteListResult.push(key);
          if (typeof parsedRFDataBannerService[key] === 'object') {
            this.rfWhitelistValidation(parsedRFDataBannerService[key]);
          }
        }
      })
    }
    return false;
  }

  /** setting User type */
  checkUserType() {
    try {
      let ecmCookie = this._cookieService.get('CBOLECM');
      if (ecmCookie === '' || ecmCookie === null || ecmCookie === undefined) {
        this.userType = 'Uncookied';
      } else {
        if (ecmCookie.split('-')[0] == 'Y' || ecmCookie.split('-')[20] == 'Y') {
          this.userType = 'Gold';
        } else {
          this.userType = 'Blue';
        }
      }
    } catch (e) {
      this.userType = 'Uncookied';
    }
  }

  /** Setting tagging data into _dl */
  getDatatoDl() {
    let taggingDataDynamicObj = {
      'acxiom_response': (this.taggingDlArr.acxiomResponse) ? this.taggingDlArr.acxiomResponse : '',
      'acxiomFailure': (this.taggingDlArr.acxiomFailure) ? this.taggingDlArr.acxiomFailure : '',
      'rf_response': (this.taggingDlArr.rfResponse) ? this.taggingDlArr.rfResponse : '',
      'rfFailure': (this.taggingDlArr.rfFailure) ? this.taggingDlArr.rfFailure : '',
      'cms_success_response': (this.taggingDlArr.cmsSuccessResponse) ? this.taggingDlArr.cmsSuccessResponse : '',
      'cms_failure_message': '',
      'pid': this.taggingDlArr.pid,
      'bullseye_success': this.taggingDlArr.bullseye_success,
      'banner_array': this.taggingDlArr.banner_array,
      'liveramp_response': this.taggingDlArr.liveRampResponse,
      'bullseye_error': (!!this.taggingDlArr.BannerOSFailure) ? `acxiom_error=${this.taggingDlArr.BannerOSFailure}`: '',
      'prospect_id': this.taggingDlArr.prospect_id
    };
    return taggingDataDynamicObj;
  }

  /** generating category from Pid as per BRD */

  setCategory(pid) {
    let category;
    if (pid && pid.length === 3 && (pid.match(/\D/) == null || (/^[a-zA-Z]+$/.test(pid) && pid != 'QLE'))) {
      // if pid value is within 3 digit numeric value or all alphabets of length 3 other then QLE
      category = 'cards';
    } else {
      //"bank:offers" first character of 4-digit pid = "C,D,L,O, or S"
      //"benefits:offers" first letter of 4-digit pid="F"
      //"branding:offers" first letter of 4-digit pid="B"
      //"content:offers" first letter of 4-digit pid = "A"
      //"investment:offers" first letter of 4-digit pid = "I"
      // "mortgage:offers" first character of 4-digit pid = "H, M, or N"
      // "retirement:offers" first character of 4-digit pid = "R"
      // "servicing:offers" first character of 4-digit pid = "Q or V" or 3-digit pid = "QLE"
      category = (this.objOfferSet && pid && pid.length === 4 && this.objOfferSet[pid.substring(0, 1)]) ? this.objOfferSet[pid.substring(0, 1)] : ((pid.length === 3 && pid === 'QLE') ? this.objOfferSet[pid] : '');
    }
    return category;
  }

}
